@if (institutionId > 0) {
  <div id="submodule-openinghours" class="cw-module-card">
    <!-- Header -->
    <div class="cw-flex-row">
      <!-- Modul-Titel -->
      <h2>{{ 'GENERAL.OPENINGHOURS' | translate }}</h2>
      <!-- Toolbar -->
      @if (data && !loading) {
        <phscw-toolbar
          componentIdentifier="institutions-openinghours"
          [componentConnection]="$any(this)"
          [buttonEditmode]="true"
          [buttonClone]="editMode"
          [buttonCancel]="true"
          buttonCloneTooltip="{{ 'MODULES.INSTITUTIONS.OPENINGHOURS.TRANSFERTIMES' | translate }}">
        </phscw-toolbar>
      }
    </div>
    <div [ngClass]="loading ? 'icon-spinner icon-spin' : ''"></div>
    <!-- Formular (für EditMode) -->
    @if (data && !loading) {
      <form #institutionsOpeninghoursForm="ngForm" (ngSubmit)="clickSubmit()" #spy>
        <!-- IDs -->
        <input type="hidden" name="id" [(ngModel)]="data.id" />
        <input type="hidden" name="institution_id" [(ngModel)]="institutionId" />
        <div class="cw-submodules">
          @if (
            editMode ||
            data.monday_start1 ||
            data.monday_start2 ||
            data.monday_end1 ||
            data.monday_end2 ||
            data.monday_preferred_time
            ) {
            <div
              class="cw-submodule">
              <h3>{{ 'GENERAL.MONDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="monday_start1"
                    inputId="monday_start1"
                    [(ngModel)]="data.monday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="monday_end1"
                    inputId="monday_end1"
                    [(ngModel)]="data.monday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.monday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="monday_start2"
                    inputId="monday_start2"
                    [(ngModel)]="data.monday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="monday_end2"
                    inputId="monday_end2"
                    [(ngModel)]="data.monday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.monday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="monday_preferred_time"
                inputId="monday_preferred_time"
              [(ngModel)]="data.monday_preferred_time"></phscw-input-text>
            </div>
          }
          @if (
            editMode ||
            data.tuesday_start1 ||
            data.tuesday_start2 ||
            data.tuesday_end1 ||
            data.tuesday_end2 ||
            data.tuesday_preferred_time
            ) {
            <div
              class="cw-submodule">
              <h3>{{ 'GENERAL.TUESDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="tuesday_start1"
                    inputId="tuesday_start1"
                    [(ngModel)]="data.tuesday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="tuesday_end1"
                    inputId="tuesday_end1"
                    [(ngModel)]="data.tuesday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.tuesday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="tuesday_start2"
                    inputId="tuesday_start2"
                    [(ngModel)]="data.tuesday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="tuesday_end2"
                    inputId="tuesday_end2"
                    [(ngModel)]="data.tuesday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.tuesday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="tuesday_preferred_time"
                inputId="tuesday_preferred_time"
              [(ngModel)]="data.tuesday_preferred_time"></phscw-input-text>
            </div>
          }
          @if (
            editMode ||
            data.wednesday_start1 ||
            data.wednesday_start2 ||
            data.wednesday_end1 ||
            data.wednesday_end2 ||
            data.wednesday_preferred_time
            ) {
            <div
              class="cw-submodule">
              <h3>{{ 'GENERAL.WEDNESDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="wednesday_start1"
                    inputId="wednesday_start1"
                    [(ngModel)]="data.wednesday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="wednesday_end1"
                    inputId="wednesday_end1"
                    [(ngModel)]="data.wednesday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.wednesday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="wednesday_start2"
                    inputId="wednesday_start2"
                    [(ngModel)]="data.wednesday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="wednesday_end2"
                    inputId="wednesday_end2"
                    [(ngModel)]="data.wednesday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.wednesday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="wednesday_preferred_time"
                inputId="wednesday_preferred_time"
              [(ngModel)]="data.wednesday_preferred_time"></phscw-input-text>
            </div>
          }
          @if (
            editMode ||
            data.thursday_start1 ||
            data.thursday_start2 ||
            data.thursday_end1 ||
            data.thursday_end2 ||
            data.thursday_preferred_time
            ) {
            <div
              class="cw-submodule">
              <h3>{{ 'GENERAL.THURSDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="thursday_start1"
                    inputId="thursday_start1"
                    [(ngModel)]="data.thursday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="thursday_end1"
                    inputId="thursday_end1"
                    [(ngModel)]="data.thursday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.thursday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="thursday_start2"
                    inputId="thursday_start2"
                    [(ngModel)]="data.thursday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="thursday_end2"
                    inputId="thursday_end2"
                    [(ngModel)]="data.thursday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.thursday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="thursday_preferred_time"
                inputId="thursday_preferred_time"
              [(ngModel)]="data.thursday_preferred_time"></phscw-input-text>
            </div>
          }
          @if (
            editMode ||
            data.friday_start1 ||
            data.friday_start2 ||
            data.friday_end1 ||
            data.friday_end2 ||
            data.friday_preferred_time
            ) {
            <div
              class="cw-submodule cw-weekend-break">
              <h3>{{ 'GENERAL.FRIDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="friday_start1"
                    inputId="friday_start1"
                    [(ngModel)]="data.friday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="friday_end1"
                    inputId="friday_end1"
                    [(ngModel)]="data.friday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.friday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="friday_start2"
                    inputId="friday_start2"
                    [(ngModel)]="data.friday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="friday_end2"
                    inputId="friday_end2"
                    [(ngModel)]="data.friday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.friday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="friday_preferred_time"
                inputId="friday_preferred_time"
              [(ngModel)]="data.friday_preferred_time"></phscw-input-text>
            </div>
          }
          @if (
            editMode ||
            data.saturday_start1 ||
            data.saturday_start2 ||
            data.saturday_end1 ||
            data.saturday_end2 ||
            data.saturday_preferred_time
            ) {
            <div
              class="cw-submodule">
              <h3>{{ 'GENERAL.SATURDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="saturday_start1"
                    inputId="saturday_start1"
                    [(ngModel)]="data.saturday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="saturday_end1"
                    inputId="saturday_end1"
                    [(ngModel)]="data.saturday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.saturday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="saturday_start2"
                    inputId="saturday_start2"
                    [(ngModel)]="data.saturday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="saturday_end2"
                    inputId="saturday_end2"
                    [(ngModel)]="data.saturday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.saturday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="saturday_preferred_time"
                inputId="saturday_preferred_time"
              [(ngModel)]="data.saturday_preferred_time"></phscw-input-text>
            </div>
          }
          @if (
            editMode ||
            data.sunday_start1 ||
            data.sunday_start2 ||
            data.sunday_end1 ||
            data.sunday_end2 ||
            data.sunday_preferred_time
            ) {
            <div
              class="cw-submodule">
              <h3>{{ 'GENERAL.SUNDAY' | translate }}</h3>
              <div class="cw-horizontalline"></div>
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="sunday_start1"
                    inputId="sunday_start1"
                    [(ngModel)]="data.sunday_start1"
                    [minuteIncrement]="15"
                    [defaultHour]="8"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="sunday_end1"
                    inputId="sunday_end1"
                    [(ngModel)]="data.sunday_end1"
                    [minuteIncrement]="15"
                    [defaultHour]="12"
                    [min]="data.sunday_start1"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              @if (enableTimeInput) {
                <div class="cw-flex-row">
                  <phscw-input-time
                    [editMode]="editMode"
                    name="sunday_start2"
                    inputId="sunday_start2"
                    [(ngModel)]="data.sunday_start2"
                    [minuteIncrement]="15"
                    [defaultHour]="14"
                  [showDeleteButton]="editMode"></phscw-input-time>
                  <phscw-input-time
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="sunday_end2"
                    inputId="sunday_end2"
                    [(ngModel)]="data.sunday_end2"
                    [minuteIncrement]="15"
                    [defaultHour]="18"
                    [min]="data.sunday_start2"
                  [showDeleteButton]="editMode"></phscw-input-time>
                </div>
              }
              <phscw-input-text
                [editMode]="editMode"
                name="sunday_preferred_time"
                inputId="sunday_preferred_time"
              [(ngModel)]="data.sunday_preferred_time"></phscw-input-text>
            </div>
          }
        </div>
        @if (enableVacations) {
          <h2>{{ 'MODULES.INSTITUTIONS.OPENINGHOURS.VACATIONS' | translate }}</h2>
        }
        @if (enableVacations) {
          <div class="cw-submodules">
            <!-- Eingabefelder -->
            <div class="cw-submodule">
              @if (editMode || data.vacation_start1 || data.vacation_end1) {
                <div class="cw-flex-row">
                  <phscw-input-date
                    [editMode]="editMode"
                    name="vacation_start1"
                    inputId="vacation_start1"
                    [(ngModel)]="data.vacation_start1"
                  (clickEvent)="correctContactEndDate(1)"></phscw-input-date>
                  <phscw-input-date
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="vacation_end1"
                    inputId="vacation_end1"
                    [(ngModel)]="data.vacation_end1"
                  (clickEvent)="correctContactEndDate(1)"></phscw-input-date>
                </div>
              }
              @if (editMode || data.vacation_start2 || data.vacation_end2) {
                <div class="cw-flex-row">
                  <phscw-input-date
                    [editMode]="editMode"
                    name="vacation_start2"
                    inputId="vacation_start2"
                    [(ngModel)]="data.vacation_start2"
                  (clickEvent)="correctContactEndDate(2)"></phscw-input-date>
                  <phscw-input-date
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="vacation_end2"
                    inputId="vacation_end2"
                    [(ngModel)]="data.vacation_end2"
                  (clickEvent)="correctContactEndDate(2)"></phscw-input-date>
                </div>
              }
              @if (editMode || data.vacation_start3 || data.vacation_end3) {
                <div class="cw-flex-row">
                  <phscw-input-date
                    [editMode]="editMode"
                    name="vacation_start3"
                    inputId="vacation_start3"
                    [(ngModel)]="data.vacation_start3"
                  (clickEvent)="correctContactEndDate(3)"></phscw-input-date>
                  <phscw-input-date
                    [editMode]="editMode"
                    label="{{ 'GENERAL.UNTIL' | translate }}"
                    name="vacation_end3"
                    inputId="vacation_end3"
                    [(ngModel)]="data.vacation_end3"
                  (clickEvent)="correctContactEndDate(3)"></phscw-input-date>
                </div>
              }
            </div>
          </div>
        }
        <!-- Buttons Submit & Cancel -->
        @if (editMode) {
          <div class="cw-button-wrapper">
            <button
              mat-raised-button
              color="accent"
              type="submit"
              [disabled]="!institutionsOpeninghoursForm.form.valid || loading || saving">
              {{ 'GENERAL.SAVE' | translate }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
            </button>
            <button mat-raised-button color="primary" type="button" (click)="clickCancel()">
              {{ 'GENERAL.CANCEL' | translate }}
            </button>
          </div>
        }
      </form>
    }
  </div>
}
